import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i3 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
export class NorthwesternMutualActivateModalComponent {
    constructor() {
        this.closeModalHandler = new EventEmitter();
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.closeModalHandler.emit();
    }
}
NorthwesternMutualActivateModalComponent.ɵfac = function NorthwesternMutualActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NorthwesternMutualActivateModalComponent)(); };
NorthwesternMutualActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NorthwesternMutualActivateModalComponent, selectors: [["ycn-northwestern-mutual-integration-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler" }, standalone: false, decls: 14, vars: 5, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "row"], [1, "col"], [1, "form-row"], [3, "submitHandler", "showCancelButton", "submitButtonText"]], template: function NorthwesternMutualActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function NorthwesternMutualActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function NorthwesternMutualActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "b");
        i0.ɵɵtext(8, "To connect your Northwestern Mutual integration to YCharts, please complete the following steps:");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtext(10, " User should sign in to YCharts using the SSO from their Northwestern Mutual portal. This will activate the integration automatically. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵtext(12, " If you have already signed in using the SSO and the integration hasn't been activated, please contact customer support. ");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(13, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("submitHandler", function NorthwesternMutualActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_13_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate Northwestern Mutual Integration");
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("showCancelButton", false)("submitButtonText", "OK");
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalFooterComponent, i3.SimpleModalHeaderComponent], encapsulation: 2 });
